module.exports = __webpack_public_path__ + "img/p4.394157ab.png";